import { EMAIL_REGEX, PHONE_NUMBER_REGEX } from 'consts';

export function isEmail(str = '') {
	return EMAIL_REGEX.test(`${str}`);
}

export function isPhoneNumber(str = '') {
	return PHONE_NUMBER_REGEX.test(`${str}`);
}

export function formatKennitala(kennitala = '') {
	return `${kennitala.slice(0, 6)}-${kennitala.slice(6)}`;
}
